import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IActTeamMemberModel } from './types';

const ActTeamMembers: IActTeamMemberModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default ActTeamMembers;
